import React from 'react';
import { ReactSVG } from 'react-svg';
import arrow from 'src/assets/images/icons/date_picker_dropdown_arror.svg';
import styles from '../DatePicker.module.scss';

const DropdownIndicator = (): JSX.Element => <ReactSVG src={arrow} className={styles.dropdownArrow} />;

export default DropdownIndicator;
